import { defineComponent as _defineComponent } from 'vue'

// Tag chips with an inline remove plus an Add tag picker of the remaining
// library tags. The same pattern the booking drawer and tracker steps carry
// inline; new consumers use this component instead of a fresh copy.
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

const __default__ = {
  name: 'tag-picker',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  }
}

import { computed } from 'vue'
import { tagChipStyle } from '@/util/tagChip'

interface Tag { id: number; name: string; color: string; is_archived?: number | boolean }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tags: null,
    catalog: null,
    saving: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    addLabel: { default: 'Add tag' },
    emptyText: { default: 'No tags' }
  },
  emits: ["add", "remove"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add', tagId: number): void
  (e: 'remove', tag: Tag): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tags: Tag[], catalog: Tag[], saving: boolean, readonly: boolean, loading: boolean, addLabel: string, emptyText: string }





const availableTags = computed(() => {
  const applied = new Set((props.tags || []).map(t => t.id))
  return (props.catalog || []).filter(t => !applied.has(t.id) && !t.is_archived)
})

function onAdd(tagId: number) {
  if (props.saving) return
  emit('add', Number(tagId))
}

return { __sfc: true,props, emit, availableTags, onAdd, tagChipStyle }
}

})